var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecure = function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.726 2.048H5.01L3.692 3.314v6.081h1V3.74l.72-.692h5.912l.72.692v5.378l-2.87 3.204H7.603v1h2.014l3.427-3.82V3.315l-1.318-1.266ZM5.067 13.822l3-4.498-.832-.555-2.703 4.053h-.415L2.72 10.78l-.825.565 1.695 2.476h1.477Z",
    fill: "currentColor"
  })));
};
export default SvgSecure;